import React, {useEffect, useRef} from "react";

import {Box, Button, Typography} from "@mui/material";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";

import { sendGAPageView } from "ui-common/GoogleAnalytics";

import manual_measure from "./img/manual_measure.svg";
import info from "./img/info.svg";

import DataCollectionPopUp from "./DataCollectionPopUp";
import {makeStyles} from "tss-react/mui";

import { mugShotNotSupported } from "./PageNavigation";
import PropTypes from "prop-types";
import StepTitle from "./StepTitle";

import { scrollToTop } from "ui-common/components/common";

const useStyles = makeStyles()((theme) => ({


    infoIconBox: {
        paddingRight: 0,
        width: 24,
        height: "100%",

        display: "flex",
        verticalAlign: "middle",
        alignItems: "center",
        justifyContent: "center"
    },

    firefoxWarning: {
        cursor: "pointer",
        display: "table",
        width: "100%",
    },


}));

const SizingScanManualPreamblePage = ( { getStarted }) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ManualPreamble");
    const { t: tChoose  } = useTranslation("pages.MaskSelectorTool.ChooseMaskSizingMethod");

    const heading = tChoose("myMeasurementsTitle");
    const scanPopupLink = tChoose("scanPopupLink");

    const subHeading = t("subHeading");
    const youllNeed = t("youllNeed");
    const mirror = t("mirror");
    const ruler = t("ruler");
    const quarter = t("quarter");

    const browserWarning = t("browserWarning");
    const getStartedButton = t("getStartedButton");

    const {classes} = MaskSelectorToolStyles();
    const {classes: localClasses} = useStyles();

    const headingRef = useRef(null);

    useEffect(() => { 
        scrollToTop();

        if(headingRef.current) {
            headingRef.current.focus();
        }
    }, []);

    const openPopOver = (event) => {
        event.preventDefault();
        setOpen(true);

        sendGAPageView("MeasureMethodPopOver");
    };

    const [open, setOpen] = React.useState(false);
    const handleClose = () => { setOpen(false); };

    return (
        <>
            <Box className={classes.chooseTopTextBox}>
                <StepTitle title={heading} />
            </Box>

            <Box className={classes.preambleSubtitle}>
                <Typography className={`${classes.subHeadingTyp} ${classes.noOutline}`} tabIndex="0" aria-label={subHeading}>{subHeading}</Typography>
            </Box>

            <Box className={classes.centeredBox} data-testid="manual_sizing_preamble_icon">
                <img className={classes.man_measure_resp_icon} src={manual_measure} alt=""/>
            </Box>

            <Box>
                <Typography>{youllNeed}</Typography>
                <ul>
                    <li>{mirror}</li>
                    <li>{ruler}</li>
                    <li>{quarter}</li>
                </ul>
            </Box>

            <Box mt="16px">
                <a href="#" className={classes.optionCardPopupLink} onClick={openPopOver}>{scanPopupLink}</a>
            </Box>


            <Box className={classes.preamble_get_started_box}>

                { mugShotNotSupported() && (

                <Box className={`${localClasses.firefoxWarning} ${classes.noOutline}`}  >
                    <Box className={classes.verticalQuestionChoiceTableRow}>
                        <Box className={` ${localClasses.infoIconBox} `}>
                            <img width="24px" src={info} alt="info"/>
                        </Box>
                        <Box ml="16px" mr="20px">
                            <Typography className={classes.res_information_text}>{browserWarning}</Typography>
                        </Box>
                    </Box>
                </Box>

            )}

                <Button
                    disableRipple
                    onClick={getStarted}
                    variant="contained"
                    color="secondary"
                    data-testid="manual-preamble-continue-button"
                    className={classes.preamble_get_started_button}
                >
                    <span>{getStartedButton}</span>
                </Button>

            </Box>

            <DataCollectionPopUp open={open} onClose={handleClose} />

        </>
    )
}
SizingScanManualPreamblePage.propTypes = {
    getStarted: PropTypes.func.isRequired
}

export default SizingScanManualPreamblePage;